module.exports = __webpack_public_path__ + "img/keder_tiefschwarz_ral9005.39a235bd.jpg";